import * as msal     from "@azure/msal-browser";
import { PublicClientApplication } from "@azure/msal-browser";
import microsoftUser from "@/models/microsoftUser";
import authError     from "@/errors/authError";


let baseUrl = process.env.VUE_APP_SIGNATURES_APP_URL;

let loginApiScopes = ["email",
	"offline_access",
	"openid",
	"profile",
	"https://signatures.garrettcounty.org/api/All"];

const authService = {

	msalConfig: {
		auth:   {
			clientId:              process.env.VUE_APP_MICROSOFT_CLIENT_ID,
			authority:             process.env.VUE_APP_MICROSOFT_AUTHORITY,
			redirectUri:           baseUrl + process.env.VUE_APP_LOGIN_REDIRECT_PATH,
			postLogoutRedirectUri: baseUrl + process.env.VUE_APP_POST_LOGOUT_PATH
		},
		cache:  {
			claimsBasedCachingEnabled: true,
			cacheLocation:          "localStorage", // This configures where your cache will be stored
			storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
		},
		system: {
			loggerOptions: {
				loggerCallback: ( level, message, containsPii ) => {
					if( containsPii ) {
						return;
					}
					switch( level ) {
						case msal.LogLevel.Error:
							console.error( message );
							return;
						case msal.LogLevel.Info:
							console.info( message );
							return;
						case msal.LogLevel.Verbose:
							console.debug( message );
							return;
						case msal.LogLevel.Warning:
							console.warn( message );
							return;
					}
				}
			}
		}
	},

	loginRequest: {
		scopes: loginApiScopes
	},

	apiRequest: {
		scopes: loginApiScopes
	},

	silentApiRequest: {
		scopes: loginApiScopes,
		redirectUri:baseUrl + process.env.VUE_APP_LOGIN_SILENT_REDIRECT_PATH
	},


	msalInstance: null,

	isSignedIn: false,

	username: '',

	constructor: async function() {
		this.msalInstance = new PublicClientApplication( this.msalConfig )
		await this.msalInstance.initialize();

		setInterval(async () => {
			await this.renewSessionProactively();
		}, 12 * 60 * 60 * 1000); //12hours
	},

	/**
	 * @returns {Promise<microsoftUser>}
	 * @throws {authError}
	 */
	pageLoad() {
		let vm = this;

		let user = new microsoftUser();

		return new Promise( function( resolve, reject ) {
			vm.msalInstance.handleRedirectPromise().then( ( response ) => {
				if( response !== null ) {
					user = new microsoftUser( response.accessToken, response.account.username, response.account.name, true );
				}
				else {
					let currentAccounts = vm.msalInstance.getAllAccounts();

					if( currentAccounts.length === 0 ) {
						// not logged in
					}
					else if( currentAccounts.length > 1 ) {
						// Add your account choosing logic here
						console.warn( "Multiple accounts detected." );
					}
					else if( currentAccounts.length === 1 ) {
						user = new microsoftUser( currentAccounts[ 0 ].accessToken, currentAccounts[ 0 ].username, currentAccounts[ 0 ].name, true );
					}
				}

				resolve( user );
			} ).catch( ( e ) => {
				reject( new authError( 'Microsoft authentication error: ' + e.message ) );
			} );

		} );
	},

	signIn() {
		this.msalInstance.loginRedirect( this.loginRequest ).then( function() {
		} );
	},

	signOut( username ) {
		/**
		 * You can pass a custom request object below. This will override the initial configuration. For more information, visit:
		 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/request-response-object.md#request
		 */

			// Choose which account to logout from by passing a username.
		const logoutRequest = {
				account: this.msalInstance.getAccountByUsername( username )
			};

		this.msalInstance.logout( logoutRequest ).then( function() {

		} );
	},

	/**
	 *
	 * @param username
	 * @returns {Promise<string>.catch<authError>} Resolved to string access token
	 * @throws {authError}
	 */
	getAccessToken( username ) {
		let vm      = this;
		let promise = new Promise(function (resolve, reject) {
			const accounts = vm.msalInstance.getAllAccounts();
			if (!accounts.length) {
				console.warn("no signed in account");
				vm.msalInstance
				  .acquireTokenPopup(vm.apiRequest)
				  .then(function (response) {
					  //redirects to the login page
					  console.log(response);
					  resolve(response.accessToken);
				  })
				  .catch((e) => {
					  reject(
						  new authError("Microsoft authentication error: " + e.message)
					  );
				  });
				return
			}
			let account = accounts[0];
			vm.silentApiRequest.account = account;

			vm.msalInstance
			  .acquireTokenSilent(vm.silentApiRequest)
			  .then(function (response) {
				  resolve(response.accessToken);
			  })
			  .catch((e) => {
				  console.warn(
					  "silent token acquisition failed. acquiring token using redirect"
				  );
				  // Check for InteractionRequired OR the specific Timeout error
				  const isInteractionRequired =
					        e instanceof msal.InteractionRequiredAuthError;
				  const isTimeout = e.errorCode === "monitor_window_timeout";

				  if (isInteractionRequired || isTimeout) {
					  console.warn(
						  "Silent token acquisition failed (Expired or Timed out). Switching to Redirect."
					  );

					  // FALLBACK popup
					  vm.msalInstance
					    .acquireTokenPopup(vm.apiRequest)
					    .then(function (response) {
						    //redirects to the login page
						    console.log(response);
						    resolve(response.accessToken);
					    });
				  } else {
					  console.warn("failing with error");
					  reject(
						  new authError("Microsoft authentication error: " + e.message)
					  );
				  }
				  /*
						if (e instanceof msal.InteractionRequiredAuthError) {
							// fallback to interaction when silent call fails
							vm.apiRequest.account = account;
							vm.msalInstance.acquireTokenRedirect(vm.apiRequest).then(function(x) {
								//redirects to the login page
					console.log(x);
							});
						} else {
							reject( new authError( 'Microsoft authentication error: '+e.message ) );
						}*/
			  });
		});

		return promise;
	},

	async renewSessionProactively() {
		let vm = this;
		let account = vm.msalInstance.getAccountByUsername(this.username);

		const longTermRequest = {
			scopes: loginApiScopes,
			account: account,
			// This forces MSAL to reach out to Azure and get a fresh 24h token
			forceRefresh: true,
		};

		try {
			console.log("Proactively renewing 24-hour session...");
			const response = await this.msalInstance.acquireTokenSilent(
				longTermRequest
			);
			console.log(
				"Session renewed successfully. New expiry:",
				response.expiresOn
			);
		} catch (e) {
			// If forceRefresh fails silently, the session is likely too old (past 24h)
			// or third-party cookies are blocked.
			console.error("Proactive renewal failed, user may need to re-login", e);
		}
	},

}

authService.constructor();

export { authService }
